import gotoLineQuickAccessSchema  from './gotoLineQuickAccess-schema.graphql';

export { gotoLineQuickAccessSchema };
